export default "/images/click.png?24ebd2feaba6d65f445c09ee0826ee01";